import { LoadingOutlined, MoreOutlined } from '@ant-design/icons';
import useExport from '@components/export/useExport';
import { Dropdown, Space } from 'antd';
import React from 'react';
import {
  ACCOUNT_LIST_FOR_USAGE_DASHBOARD_QUERY_KEY,
  USAGE_METRIC_SERIES_QUERY_KEY,
} from '@components/usage-dashboard/constant';
import { useIsFetching } from '@tanstack/react-query';

export const usageExportConfig = {
  page: { key: 'usageDashboard', title: 'Usage Dashboard' },
  sections: [
    { key: 'ud-summary', title: '' },
    { key: 'ud-video-metric-timeseries' },
    { key: 'ud-app-metric-timeseries' },
    { key: 'ud-api-metric-timeseries' },
    { key: 'ud-video-metric-table' },
    { key: 'ud-app-metric-table' },
    { key: 'ud-api-metric-table' },
  ],
};

export const Kebab = () => {
  const { triggerDownload } = useExport({ config: usageExportConfig });
  const isAccountListFetching = useIsFetching([ACCOUNT_LIST_FOR_USAGE_DASHBOARD_QUERY_KEY]) > 0;
  const isUsageMetricFetching = useIsFetching([USAGE_METRIC_SERIES_QUERY_KEY]) > 0;
  const isFetching = isAccountListFetching || isUsageMetricFetching;

  const kebabItems = [
    {
      key: '1',
      label: <a onClick={triggerDownload}>Export</a>,
      disabled: isFetching,
      icon: isFetching ? <LoadingOutlined /> : null,
    },
  ];

  return (
    <Dropdown menu={{ items: kebabItems }} trigger={['click']}>
      <Space style={{ lineHeight: 2, fontSize: 18, cursor: 'pointer' }}>
        <MoreOutlined />
      </Space>
    </Dropdown>
  );
};
